module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-12ccdde05f94a672b41450db6c187ef3.webp";